import type { LandingPageFeature } from "@brookbush/types";

import clsx from "clsx";
import Image from "next/image";
import type * as React from "react";

import SectionContainer from "~/components/SectionContainer";
import { getFeatureThumbnailClassNames } from "~/lib/landingPageFeatureThumbnail";

interface LandingPageFeaturesProps {
	features: LandingPageFeature[];
}

const LandingPageFeatures: React.FC<LandingPageFeaturesProps> = ({
	features,
}) => {
	return (
		<SectionContainer
			className="flex flex-col gap-12 border-b"
			title="Features"
		>
			<h2 className="text-center font-bold text-2xl sm:text-4xl lg:text-4xl">
				Key Features
			</h2>

			<div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
				<div className="grid grid-cols-1 gap-10 md:grid-cols-3">
					{features.map((feature) => (
						<div
							key={feature.title}
							className="flex flex-col gap-4 text-center"
						>
							<div
								className={clsx(
									"relative aspect-video w-full overflow-hidden rounded-xl border",
									feature.thumbnail &&
										getFeatureThumbnailClassNames(feature.thumbnail.url)
											.container,
								)}
							>
								{feature.thumbnail && (
									<Image
										src={feature.thumbnail.url}
										alt={feature.title}
										fill
										className={
											getFeatureThumbnailClassNames(feature.thumbnail.url).image
										}
										unoptimized
									/>
								)}
							</div>
							<h3 className="mt-2 font-medium text-lg">{feature.title}</h3>
							<p>{feature.description}</p>
						</div>
					))}
				</div>
			</div>
		</SectionContainer>
	);
};

export default LandingPageFeatures;
